import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";

const Dashboard = () => {
  const [properties, setProperties] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("isAuthenticated") !== "true") {
      navigate("/login");
    } else {
      fetchProperties();
    }
  }, []);

  const fetchProperties = async () => {
    try {
      const response = await fetch(
        "https://realo-realestate.com/api/api/Property/GetProperties"
      );
      const data = await response.json();
      setProperties(data);
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };

  const handleDeleteProperty = async (id) => {
    await fetch(
      `https://realo-realestate.com/api/api/Property/DeleteProperty/${id}`,
      {
        method: "DELETE",
      }
    );
    setProperties(properties.filter((property) => property.propertyId !== id));
  };

  const handleEditProperty = (propertyId) => {
    navigate(`/Dashboard/EditProperty/${propertyId}`);
  };

  const handleManageImages = (propertyId) => {
    navigate(`/Dashboard/ManagePropertyImages/${propertyId}`);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("isAuthenticated");
    navigate("/login");
  };

  return (
    <div className="dashboard-container">
      <h1>Property Management Dashboard</h1>
      <button onClick={() => navigate("/Dashboard/AddProperty")}>
        Add New Property
      </button>
      <button onClick={handleLogout} style={{ marginLeft: "10px" }}>
        Logout
      </button>

      <table className="property-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Description</th>
            <th>Address</th>
            <th>City</th>
            <th>State</th>
            <th>Zip Code</th>
            <th>Property Type</th>
            <th>For Sale</th>
            <th>For Rent</th>
            <th>Price</th>
            <th>Bedrooms</th>
            <th>Bathrooms</th>
            <th>Square Feet</th>
            <th>Available</th>
            <th>Orientation</th>
            <th>Furniture</th>
            <th>Heating System</th>
            <th>Additional Features</th>
            <th>Ownership Document</th>
            <th>Spaces</th>
            <th>Floor Level</th>
            <th>Country</th>
            <th>Neighborhood</th>
            <th>Builder</th>
            <th>Complex</th>
            <th>Latitude</th>
            <th>Longitude</th>
            <th>Exterior Video</th>
            <th>Interior Video</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {properties.map((property, index) => (
            <tr key={index}>
              <td>{property.propertyId}</td>
              <td>{property.title}</td>
              <td id="description">{property.description}</td>
              <td>{property.address}</td>
              <td>{property.city}</td>
              <td>{property.state}</td>
              <td>{property.zipCode}</td>
              <td>{property.propertyType}</td>
              <td>{property.isForSale ? "Yes" : "No"}</td>
              <td>{property.isForRent ? "Yes" : "No"}</td>
              <td>${property.price}</td>
              <td>{property.bedrooms}</td>
              <td>{property.bathrooms}</td>
              <td>{property.squareFeet}</td>
              <td>{property.isAvailable ? "Yes" : "No"}</td>
              <td>{property.orientation}</td>
              <td>{property.furniture}</td>
              <td>{property.heatingSystem}</td>
              <td>{property.additionalFeatures}</td>
              <td>{property.hasOwnershipDocument ? "PO" : "JO"}</td>
              <td>{property.spaces}</td>
              <td>{property.floorLevel}</td>
              <td>{property.country}</td>
              <td>{property.neighborhood}</td>
              <td>{property.builder}</td>
              <td>{property.complex}</td>
              <td>{property.latitude}</td>
              <td>{property.longitude}</td>
              <td>{property.exteriorVideo}</td>
              <td>{property.interiorVideo}</td>
              <td>
                <button onClick={() => handleEditProperty(property.propertyId)}>
                  Edit
                </button>
                <button
                  onClick={() => handleDeleteProperty(property.propertyId)}
                >
                  Delete
                </button>
                <button onClick={() => handleManageImages(property.propertyId)}>
                  Manage Images
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Dashboard;
